import {
	ClientInsuredPersonRiskVariantEnum,
	type InsuredPersonDTO,
	type InsuredPersonRiskDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import {
	joinTruthy,
	nameFormatter,
} from "web_myplann/Shared/Utils/textFormatters";

const PageResources = Resources.PortfolioDetail;

export const getInsuredPersonName = (person: InsuredPersonDTO) =>
	joinTruthy([person.firstname, person.lastname], " ");

export const getInsuredPersonLabel = (person: InsuredPersonDTO) =>
	nameFormatter(
		getInsuredPersonName(person),
		null,
		person.identificationNumber,
	);

export const getInsuredRiskCaption = (
	risk: InsuredPersonRiskDTO,
	t: TranslateFunction,
) => {
	const untilAge =
		typeof risk.toAge === "number"
			? t(PageResources.SharedLabels.untilAge, {
					count: risk.toAge,
				})
			: null;
	const variant =
		risk.variant && risk.variant !== ClientInsuredPersonRiskVariantEnum.Empty
			? t(
					PageResources.LifeInsurance.EnsuredPeople.Variant[risk.variant],
				).toLowerCase()
			: null;

	return [untilAge, variant].filter(Boolean).join(" · ") || undefined;
};
